"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventStartTime = exports.getEventStartDate = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var formatTime = function formatTime(timestamp) {
  return (0, _momentTimezone["default"])(timestamp).utc().format('h:mma');
};
var formatTimezone = function formatTimezone(timestamp) {
  return (0, _momentTimezone["default"])(timestamp).tz('America/New_York').format('z');
};
var getEventStartDate = exports.getEventStartDate = function getEventStartDate(timestamp) {
  return (0, _momentTimezone["default"])(timestamp).format('MMMM DD, YYYY');
};
var getEventStartTime = exports.getEventStartTime = function getEventStartTime(startOn, endOn) {
  return "".concat(formatTime(startOn), " - ").concat(formatTime(endOn), " ").concat(formatTimezone(startOn));
};